import { Component, OnInit } from '@angular/core';
import { AppService } from './appservice.service';
import { TranslateService } from '@ngx-translate/core';

declare var require: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  title = 'Bills & more';
  year = (new Date()).getFullYear();

  // tslint:disable-next-line: max-line-length
  vendorlogo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAMSURBVBhXY/j//z8ABf4C/qc1gYQAAAAASUVORK5CYII=';

  ngOnInit(): void {
  }

  constructor(public translate: TranslateService, public service: AppService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    this.service.checkReady();
    try {
      const vl = this.service.getVendorLogo();
      if (vl !== '') {
        this.vendorlogo = vl;
      }
    } catch (ex) {
      console.log('vendor logo error ' + ex);
    }
  }

  clearMessage(): void {
    this.service.clearMessage();
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }
}
